import React from 'react';

import Head from 'react-scale/components/pages/docs/head';
import Main from 'react-scale/components/pages/docs/Main';

const Docs = ({
  topLevelNavigation,
  subLevelNavigation,
  title,
  content,
  slug,
  updated
}) => (
  <div>
    <Head
      title={`${title} | Scale.com Guide`}
      description="Scale AI’s mission is to accelerate the development of AI applications. Check out our on demand or enterprise solutions."
      canonical={`https://scale.com/docs/${slug}`}
      ogImg="https://scale.com/static/img/website/docs/social/fb.png"
      twImg="https://scale.com/static/img/website/docs/social/tw.png"
    />
    <Main
      topLevelNavigation={topLevelNavigation}
      subLevelNavigation={subLevelNavigation}
      title={title}
      content={content}
      slug={slug}
      updated={updated}
    />
  </div>
);

Docs.defaultProps = {
  title: 'Documentation'
};

export default Docs;
